import axios from "axios";
import { windowRedirectTo } from "./common-utils";
import CONSTANTS from "./constants";
import { getCookie } from "./identity-utils";
import { unauthedRedirectRoute } from '../components/authenticated-route/authenticated-route'

// Request interceptor for API calls
axios.interceptors.request.use(
  config => {
    const userToken = getCookie(CONSTANTS.USER_TOKEN_KEY);
    if (userToken) {
      config.headers['Authorization'] = userToken;
    }
    return config;
  },
);

// Response interceptor for API calls
axios.interceptors.response.use((response) => {
  return response;
}, (error) => {
  const { response } = error;
  const responseCode = response?.data?.error?.statusCode;

  switch (responseCode) {
    case 401:
      windowRedirectTo(unauthedRedirectRoute(window.location.pathname));
      break;
    default:
  }

  return Promise.reject(error);
});